import { useEffect, useState } from "react";
import { toast } from "sonner";
import { GENDERS, GenderFields } from "@/components/onboarding/GenderStep";
import { api, errMsg } from "@/lib/api";

const label = (id) => GENDERS.find(([g]) => g === id)?.[1];

export const ProfileSection = () => {
  const [stored, setStored] = useState(null);
  const [value, setValue] = useState({ gender: null, self_description: "", store: true });

  useEffect(() => {
    api.get("/profile").then(({ data }) => {
      setStored(data);
      setValue({ gender: data.gender || "prefer_not_to_say", self_description: data.gender_self_description || "", store: !!data.gender });
    }).catch((e) => toast.error(errMsg(e)));
  }, []);

  const save = async () => {
    try {
      const { data } = await api.put("/profile/gender", value);
      setStored(data);
      toast.success(data.gender ? "Gender updated." : "Saved — no gender stored.");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async () => {
    try {
      const { data } = await api.delete("/profile/gender");
      setStored(data);
      setValue({ gender: "prefer_not_to_say", self_description: "", store: false });
      toast.success("Gender information deleted.");
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!stored) return null;
  return (
    <section className="panel p-6 sm:p-8 space-y-5" data-testid="settings-profile">
      <div>
        <h2 className="text-lg font-semibold">About you (private)</h2>
        <p className="text-xs text-muted-foreground mt-1">Used only to personalise suggested replies (e.g. Hindi grammar). Never shown publicly.</p>
      </div>
      <div className="text-sm" data-testid="settings-gender-current">Currently stored: <span className="font-semibold">{stored.gender ? `${label(stored.gender)}${stored.gender_self_description ? ` — ${stored.gender_self_description}` : ""}` : "Nothing"}</span></div>
      <GenderFields value={value} setValue={setValue} />
      <div className="flex flex-wrap gap-2">
        <button data-testid="settings-gender-save-button" disabled={!value.gender} onClick={save} className="h-10 px-5 rounded-full brand-gradient text-white text-sm font-semibold disabled:opacity-40">Update</button>
        <button data-testid="settings-gender-delete-button" disabled={!stored.gender} onClick={remove} className="h-10 px-5 rounded-full border border-border text-sm font-medium disabled:opacity-40">Delete my gender info</button>
      </div>
    </section>
  );
};
